import React from "react";

import ReactPlayer from "react-player";

export const onKeyDownVideo = (
  videoPlayer: React.RefObject<ReactPlayer>,
  event: React.KeyboardEvent<HTMLElement>,
) => {
  // https://github.com/cookpete/react-player/issues/724 event binding isn't consistent
  // event.preventDefault();
  const { current: videoPlayerRef } = videoPlayer;
  if (!videoPlayerRef) return;
  const currentTime = videoPlayerRef.getCurrentTime();
  switch (event.key) {
    case "ArrowLeft":
      videoPlayerRef.seekTo(currentTime - 8); // wistia default is +-2 seconds so +- 8 to get 10 seconds
      break;
    case "ArrowRight":
      videoPlayerRef.seekTo(currentTime + 8);
      break;
    default:
      break;
  }
};
